import React from 'react';
import {useTags} from '../../../hooks/api/tags';
import {ObjectId} from 'bson';
import {loadingTextsFor} from './utils';
import {FilterSelect} from './FilterSelect';
import {FilterControlWithNegate} from './FilterControlWithNegate';

const TagFilterLoadingTexts = loadingTextsFor('tags');

export const TagsFilterControl = ({
  value,
  negate,
  onChange,
  onRemove,
  staticTagsOnly,
}: {
  value: ObjectId[];
  negate?: boolean;
  onChange: (value: ObjectId[], negate?: boolean) => void;
  onRemove: () => void;
  staticTagsOnly?: boolean;
}) => {
  const tags = useTags(staticTagsOnly ? {type: 'static'} : {});
  const tagOptions = React.useMemo(
    () =>
      tags.data?.map((tag) => ({
        value: tag._id,
        label: tag.name,
      })),
    [tags.data]
  );

  const selectedTagOptions = React.useMemo(
    () =>
      tagOptions?.filter((tagOption) =>
        value.find((id) => id.equals(tagOption.value))
      ),
    [value, tagOptions]
  );

  if (!tagOptions?.length) {
    return null;
  }

  return (
    <FilterControlWithNegate
      value={value}
      negate={negate}
      onChange={onChange}
      onRemove={onRemove}
    >
      {(_, onValueChange) => (
        <FilterSelect
          noOptionsMessage={() => TagFilterLoadingTexts[tags.status]}
          options={tagOptions}
          isMulti
          onChange={(values) => {
            onValueChange(values.map((v) => v.value));
          }}
          value={selectedTagOptions}
        />
      )}
    </FilterControlWithNegate>
  );
};
